import { Injectable } from "@angular/core";
import { Lookup } from "../../../business-objects/lookup/lookup.model";
import { CheckBoxListControlValue } from "./check-box-list-control-value.model";
import { MultiSelectOption } from "../../../../core/interfaces/multi-select-option";
import { isInArray } from "../../../../core/util/is-in-array";
import { CheckBoxListControlValueItem } from "./check-box-list-control-value-item.model";
import { BaseController } from "../../../../core/controllers/base.controller";
import { VasAppFacade } from "../../../services/vas-app-facade.service";

@Injectable()
export class CheckBoxListControlController extends BaseController {

    lookups: Array<Lookup>;

    constructor(protected appFacade: VasAppFacade) {
        super();
        this.appFacade.objects.lookup.store
            .getAll()
            .takeUntil(this.ngUnsubscribe)
            .subscribe(lookups => this.lookups = lookups);
    }

    getItems(value: CheckBoxListControlValue, lookupType: string, defaultValue: boolean): Array<MultiSelectOption> {

        return this.lookups
            .filter(lookup => lookup.lookupType === lookupType)
            .map(lookup => {
                const checked = value ? value.has(lookup.id) : defaultValue;
                return new MultiSelectOption(lookup.id, lookup.title, checked);
            })
            .sort((a, b) => a.label.localeCompare(b.label));
    }

    getValue($event: Array<string>): CheckBoxListControlValue {
        const items: Array<CheckBoxListControlValueItem> = this.lookups
            .filter(lookup => isInArray(lookup.id, $event))
            .map(lookup => new CheckBoxListControlValueItem({id: lookup.id, value: lookup.title}));
        return new CheckBoxListControlValue(items);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/check-box-list/form/check-box-list-control.controller.ts